var states = require('./states');

module.exports = statesConvert;

function statesConvert(from, to) {
  var mapper = states.reduce(function reducer(map, data) {
    map[data[from]] = data[to];
    return map;
  }, {});
  return function converter(value) {
    return mapper[value];
  };
}